export const TOKEN_KEY = 'token';
export const USER_KEY = 'user';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const CART_KEY = 'kalpavriksha_cart';
export const CART_PREVIEWS_KEY = 'kalpavriksha_cart_previews';
export const PENDING_CART_ITEM_KEY = 'pendingCartItem';
